"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _FacetType = _interopRequireDefault(require("./FacetType"));

var _FacetValue = _interopRequireDefault(require("./FacetValue"));

var _default = _propTypes.default.shape({
  data: _propTypes.default.arrayOf(_FacetValue.default).isRequired,
  field: _propTypes.default.string.isRequired,
  type: _FacetType.default.isRequired
});

exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy90eXBlcy9GYWNldC5qcyJdLCJuYW1lcyI6WyJQcm9wVHlwZXMiLCJzaGFwZSIsImRhdGEiLCJhcnJheU9mIiwiRmFjZXRWYWx1ZSIsImlzUmVxdWlyZWQiLCJmaWVsZCIsInN0cmluZyIsInR5cGUiLCJGYWNldFR5cGUiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBOztBQUNBOztBQUNBOztlQUVlQSxtQkFBVUMsS0FBVixDQUFnQjtBQUM3QkMsRUFBQUEsSUFBSSxFQUFFRixtQkFBVUcsT0FBVixDQUFrQkMsbUJBQWxCLEVBQThCQyxVQURQO0FBRTdCQyxFQUFBQSxLQUFLLEVBQUVOLG1CQUFVTyxNQUFWLENBQWlCRixVQUZLO0FBRzdCRyxFQUFBQSxJQUFJLEVBQUVDLG1CQUFVSjtBQUhhLENBQWhCLEMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUHJvcFR5cGVzIGZyb20gXCJwcm9wLXR5cGVzXCI7XG5pbXBvcnQgRmFjZXRUeXBlIGZyb20gXCIuL0ZhY2V0VHlwZVwiO1xuaW1wb3J0IEZhY2V0VmFsdWUgZnJvbSBcIi4vRmFjZXRWYWx1ZVwiO1xuXG5leHBvcnQgZGVmYXVsdCBQcm9wVHlwZXMuc2hhcGUoe1xuICBkYXRhOiBQcm9wVHlwZXMuYXJyYXlPZihGYWNldFZhbHVlKS5pc1JlcXVpcmVkLFxuICBmaWVsZDogUHJvcFR5cGVzLnN0cmluZy5pc1JlcXVpcmVkLFxuICB0eXBlOiBGYWNldFR5cGUuaXNSZXF1aXJlZFxufSk7XG4iXX0=